import { render, staticRenderFns } from "./FlavourButton.vue?vue&type=template&id=2dae2284&scoped=true&"
import script from "./FlavourButton.vue?vue&type=script&lang=js&"
export * from "./FlavourButton.vue?vue&type=script&lang=js&"
import style0 from "./FlavourButton.vue?vue&type=style&index=0&id=2dae2284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae2284",
  null
  
)

export default component.exports